/* WORQUX theme — interactions. Checkout & cart handled by Shopify. */
(function () {
  var d = document;

  /* ---- Mobile menu ---- */
  var toggle = d.querySelector('[data-menu-toggle]');
  var mobileNav = d.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) toggle.addEventListener('click', function () { mobileNav.classList.toggle('open'); });

  /* ---- Cart count ---- */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { d.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + c.item_count + ')'; }); })
    .catch(function () {});

  /* ---- Scroll reveal ---- */
  var reveals = d.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- PDP gallery thumbnails ---- */
  var mainImg = d.getElementById('pdp-main-img');
  d.querySelectorAll('.pdp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg && t.dataset.full) mainImg.src = t.dataset.full;
      d.querySelectorAll('.pdp-thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* ---- PDP variant swatches ---- */
  var vidInput = d.getElementById('pdp-variant-id');
  var priceNow = d.querySelector('#pdp-price .price-now');
  var priceWas = d.querySelector('#pdp-price .price-was');
  var atcPrice = d.getElementById('pdp-atc-price');
  var stickyPrice = d.getElementById('sticky-price');
  var optLabel = d.getElementById('pdp-opt-label');
  d.querySelectorAll('.swatch').forEach(function (s) {
    s.addEventListener('click', function () {
      if (s.dataset.available === 'false') return;
      d.querySelectorAll('.swatch').forEach(function (x) { x.classList.remove('active'); });
      s.classList.add('active');
      if (vidInput) vidInput.value = s.dataset.vid;
      if (priceNow) priceNow.textContent = s.dataset.price;
      if (atcPrice) atcPrice.textContent = s.dataset.price;
      if (stickyPrice) stickyPrice.textContent = s.dataset.price;
      if (optLabel) optLabel.textContent = s.dataset.title;
      if (priceWas) { if (s.dataset.compare) { priceWas.textContent = s.dataset.compare; priceWas.style.display = ''; } else { priceWas.style.display = 'none'; } }
    });
  });

  /* ---- Sticky add-to-cart ---- */
  var atc = d.getElementById('pdp-atc');
  var sticky = d.getElementById('sticky-atc');
  if (atc && sticky && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    so.observe(atc);
  }

  /* ---- Announcement rotator ---- */
  var rot = d.querySelector('[data-rotator]');
  if (rot) {
    var msgs = rot.querySelectorAll('.announce-msg');
    if (msgs.length > 1) {
      var idx = 0;
      setInterval(function () {
        msgs[idx].classList.remove('on');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.add('on');
      }, 3400);
    }
  }
})();
